'use client';
import { Typography } from '@curology/ui-components-web/react/Typography';
import Image from 'next/image';
import React from 'react';

import { type PhotoUploader } from '../types/types';

const ExamplePhoto = ({ uploader }: { uploader: PhotoUploader }) => {
  return (
    <div className="cur-flex-1 cur-text-center">
      <div className="cur-pr-2">
        <Typography className="cur-mb-2" weight="bold">
          Example
        </Typography>
        <div className="cur-relative">
          <Image
            alt={uploader.examplePhoto.alt || 'Example image'}
            width={uploader.examplePhoto.width || 200}
            height={uploader.examplePhoto.width || 200}
            src={uploader.examplePhoto.src}
          />
        </div>
      </div>
    </div>
  );
};

export default ExamplePhoto;
